import { render, staticRenderFns } from "./createMessageWise.vue?vue&type=template&id=5d9a762a&scoped=true&"
import script from "./createMessageWise.vue?vue&type=script&lang=js&"
export * from "./createMessageWise.vue?vue&type=script&lang=js&"
import style0 from "./createMessageWise.vue?vue&type=style&index=0&id=5d9a762a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9a762a",
  null
  
)

export default component.exports